/**
 * Provides internal NIST object identifiers (OIDs) for hash and signature algorithms.
 *
 * @private
 */
var _NistObjectIdentifiers = /** @class */ (function () {
    function _NistObjectIdentifiers() {
        /**
         * OID for the SHA-256 hash algorithm.
         *
         * @private
         */
        this._secureHash256AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.2.1' }; //eslint-disable-line
        /**
         * OID for the SHA-384 hash algorithm.
         *
         * @private
         */
        this._secureHash384AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.2.2' }; //eslint-disable-line
        /**
         * OID for the SHA-512 hash algorithm.
         *
         * @private
         */
        this._secureHash512AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.2.3' }; //eslint-disable-line
        /**
         * OID for RIPEMD-160 (race evaluation message digest).
         *
         * @private
         */
        this._raceEvaluationMessageDigestAlgorithmIdentifier = { id: '1.3.36.3.2.1' }; //eslint-disable-line
        /**
         * OID for the SHA-256 signature algorithm identifier.
         *
         * @private
         */
        this._digitalSignatureWithSecureHash256AlgorithmIdentifier = { id: '2.16.840.1.101.3.4.3.2' }; //eslint-disable-line
        /**
         * OID for the RIPEMD-160 with RSA (race evaluation with Ron cipher) algorithm identifier.
         *
         * @private
         */
        this._ronCipherWithRaceEvaluationAlgorithmIdentifier = { id: '1.3.36.3.3.1.2' }; //eslint-disable-line
    }
    return _NistObjectIdentifiers;
}());
export { _NistObjectIdentifiers };
/**
 * OID for the RIPEMD-160 with RSA (race evaluation with Ron cipher) algorithm identifier.
 *
 * @private
 */
var _PdfCryptographicObjectIdentifier = /** @class */ (function () {
    function _PdfCryptographicObjectIdentifier() {
        /**
         * OID for the MD5 message-digest.
         *
         * @private
         */
        this._messageDigest5 = { id: '1.2.840.113549.2.5' }; //eslint-disable-line
        /**
         * OID for SHA-1 with RSA encryption.
         *
         * @private
         */
        this._secureHash1WithRonCipherEncryption = { id: '1.2.840.113549.1.1.5' }; //eslint-disable-line
        /**
         * OID for SHA-256 with RSA encryption.
         *
         * @private
         */
        this._secureHash256WithRonCipherEncryption = { id: '1.2.840.113549.1.1.11' }; //eslint-disable-line
        /**
         * OID for SHA-384 with RSA encryption.
         *
         * @private
         */
        this._secureHash384WithRonCipherEncryption = { id: '1.2.840.113549.1.1.12' }; //eslint-disable-line
        /**
         * OID for SHA-512 with RSA encryption.
         *
         * @private
         */
        this._secureHash512WithRonCipherEncryption = { id: '1.2.840.113549.1.1.13' }; //eslint-disable-line
        /**
         * OID for MD2 with RSA encryption.
         *
         * @private
         */
        this._messageDigest2WithRonCipherEncryption = { id: '1.2.840.113549.1.1.2' }; //eslint-disable-line
        /**
         * OID for RSA encryption (public key).
         *
         * @private
         */
        this._raceEvaluationEncryption = { id: '1.2.840.113549.1.1.1' }; //eslint-disable-line
    }
    return _PdfCryptographicObjectIdentifier;
}());
export { _PdfCryptographicObjectIdentifier };
/**
 * Provides internal CMS/PKCS digital content and attribute OIDs used in signatures.
 *
 * @private
 */
var _PdfDigitalIdentifiers = /** @class */ (function () {
    function _PdfDigitalIdentifiers() {
        /**
         * OID for PKCS#7 Data content type.
         *
         * @private
         */
        this._cryptographicData = '1.2.840.113549.1.7.1';
        /**
         * OID for PKCS#7 SignedData content type.
         *
         * @private
         */
        this._cryptographicSignedData = '1.2.840.113549.1.7.2';
        /**
         * OID for RSA encryption (public key).
         *
         * @private
         */
        this._rsaEncryption = '1.2.840.113549.1.1.1';
        /**
         * OID for DSA signature (public key algorithm).
         *
         * @private
         */
        this._dsaSignature = '1.2.840.10040.4.1';
        /**
         * OID for EC public key (public key algorithm).
         *
         * @private
         */
        this._ecPublicKey = '1.2.840.10045.2.1';
        /**
         * OID for the CMS ContentType attribute.
         *
         * @private
         */
        this._contentType = '1.2.840.113549.1.9.3';
        /**
         * OID for the CMS MessageDigest attribute.
         *
         * @private
         */
        this._messageDigest = '1.2.840.113549.1.9.4';
        /**
         * OID for the CMS SigningCertificate attribute.
         *
         * @private
         */
        this._signingCertificate = '1.2.840.113549.1.9.16.2.47';
        /**
         * OID for the Adobe RevocationInfoArchival attribute.
         *
         * @private
         */
        this._revocation = '1.2.840.113583.1.1.8';
    }
    return _PdfDigitalIdentifiers;
}());
export { _PdfDigitalIdentifiers };
